import React from 'react'
import Loading from '@components/SuspenseLoading/Loading'
import {getWebsitePublications_website_publications} from '@data/queries/components/__generated__/getWebsitePublications'
import {websitePublicationsQuery} from '@data/queries/components/publications'
import isServerSide from '@helpers/misc/isServerSide'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery as useQuery} from 'apollo-hooks'

import Publication from './Publication'

import styles from './styles.module.css'

export default function List(props: {
  ssrPublications?: getWebsitePublications_website_publications
}) {
  const {website} = useQuery({
    query: websitePublicationsQuery,
    variables: {
      websiteId: useWebsiteId()
    },
    omit: isServerSide(),
    partial: true
  })

  const publications = website?.publications ? website.publications : props.ssrPublications
  if (isServerSide() && !props.ssrPublications) {
    console.warn(
      'Could not fetch publications while doing SSR. This should be fixed for an optimized experience'
    )
    return <Loading />
  }

  if (!publications) {
    return <Loading />
  }

  return (
    <div className={styles.container}>
      <div className="row center-xs">
        {publications.map(publication => (
          <div className="col-xs-12 col-sm-6 col-md-4 col-lg-3" key={publication._id}>
            <Publication publication={publication} />
          </div>
        ))}
      </div>
    </div>
  )
}
